import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
})
export class DatepickerComponent implements OnInit {
  @Input() isInvalid: boolean = false;
  @Input() small_input: boolean;
  @Input() blankInitially: boolean = false;
  @Input() date: string;
  @Input() full_width: boolean = false;
  @Input() separator: string = '/';
  @Output() date_result: EventEmitter<string> = new EventEmitter();
  @Input() isReadonly: boolean = false;

  constructor() {}

  // Component lifecycle events
  ngOnInit() {
    if (!this.date && !this.blankInitially) this.setDate(new Date());
    console.log("isReadonly", this.isReadonly);
  }

  // Component methods
  onDateSelect(date_selected: any) {
    this.date = date_selected;
    this.date_result.emit(this.date);
  }

  setDate(date: any) {
    if (typeof date == 'object') {
      var d = date.getDate();
      if (d < 10) d = '0' + d;
      var m = date.getMonth() + 1;
      if (m < 10) m = '0' + m;
      var y = date.getFullYear();
      this.date = `${m}${this.separator}${d}${this.separator}${y}`;
      this.date_result.emit(this.date);
    }
  }
}
